import { render, staticRenderFns } from "./BookingPolicyForm.vue?vue&type=template&id=40824710"
import script from "./BookingPolicyForm.vue?vue&type=script&lang=js"
export * from "./BookingPolicyForm.vue?vue&type=script&lang=js"
import style0 from "./BookingPolicyForm.vue?vue&type=style&index=0&id=40824710&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports